import Loancalculationdocs from "../../../jsx/components/Dashboard/LoanCalculation/LoanCalculationDocs/loancalculationdocs";

const LoanCalculationDocsWrapper = () => {
  return <Loancalculationdocs />;
};

export default constore(LoanCalculationDocsWrapper);
